module.exports = __webpack_public_path__ + "static/a-sound-of-thunder-and-other-stories-11152e27e58b1ae6a96c11bbc13d7c31.jpg";